var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateDownward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 0 0-9 9h18a9 9 0 0 0-9-9Zm0 18a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z",
    fill: "#9DA6AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.776 13.22a.61.61 0 0 0-.6.723c.054.295.33.497.63.497h.943l.547-.077c-.875 1.283-2.393 1.874-4.054 1.613a3.862 3.862 0 0 1-3.004-2.404c-1.11-2.899 1.007-5.667 3.766-5.667 1.438 0 2.699.842 3.422 1.858v.022a.613.613 0 0 0 .85.164.602.602 0 0 0 .175-.8h.005a5.28 5.28 0 0 0-4.819-2.426c-2.63.177-4.76 2.33-4.91 4.963-.176 3.063 2.254 5.565 5.277 5.565a5.232 5.232 0 0 0 3.978-1.81l-.115.642v.58c0 .3.202.577.497.63a.61.61 0 0 0 .723-.6V13.22h-3.311Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateDownward);
export default __webpack_public_path__ + "static/media/rotate-downward.6e340064.svg";
export { ForwardRef as ReactComponent };